import PropTypes from "prop-types";
import styled from "styled-components";
import { breakpoints } from "styles/grid";
import Button from "components/base/Button";
import Block from "components/layout/Block";
import Icon from "components/global/Icon";
import Image from "components/layout/Image";

// ** SVG Static Imports
import { ReactComponent as LightTimes } from "resources/icons/light/times.svg";

const Wrapper = styled((props) => <Block {...props} />)`
	position: relative;
	max-width: 220px;
	margin-right: 1rem;

	@media (max-width: ${breakpoints.phone - 1}px) {
		margin-right: 0;
	}
`;

const StyledButton = styled(Button)`
	position: absolute;
	top: 0.5rem;
	right: 0.5rem;
	width: 2rem;
	height: 2rem;
	line-height: 2rem;
	font-size: 1.4rem;
	text-align: center;

	svg {
		color: ${({ theme: { colors } }) => colors.whiteAlways};
	}
`;

const UploadPreview = ({ src, handleDelete }) => {
	return (
		<Wrapper>
			<StyledButton label="Usuń" onClick={handleDelete}>
				<Icon svgIconComponent={LightTimes} type="fal">
					times
				</Icon>
			</StyledButton>
			<Image
				src={src}
				alt=""
				fluid
				style={{
					maxWidth: "220px",
					maxHeight: "220px",
				}}
			/>
		</Wrapper>
	);
};

UploadPreview.propTypes = {
	data: PropTypes.string,
	handleDelete: PropTypes.func,
};

export default UploadPreview;
